import { useContext } from 'react';

import CreditContext from 'apps/web/context/credits/context';
import { calculateCreditUsage } from 'apps/web/utils/creditUsage';

import GenerateButton from '../GenerateButton';

interface Props {
  buttonText: string;
  isRegularDefault?: boolean;
  isDisabled: boolean;
  creditCost: number;
  handleOnCLick: () => void;
}

export default function DynamicLabelGenerateButton(props: Props) {
  const {
    buttonText,
    isRegularDefault,
    isDisabled,
    creditCost,
    handleOnCLick,
  } = props;
  const { context: creditContext } = useContext(CreditContext);
  const { userCredit } = creditContext;
  const { paidCredits: userPaidCredits = 0 } = userCredit;
  const { regularCredits, premiumCredits } = calculateCreditUsage(
    isRegularDefault,
    userCredit,
    userPaidCredits,
    creditCost,
  );

  return (
    <GenerateButton
      isMixedCredits
      buttonText={buttonText}
      disabled={isDisabled}
      premiumCredits={premiumCredits}
      regularCredits={regularCredits}
      onClick={handleOnCLick}
    />
  );
}
